import { render, staticRenderFns } from "./CreatePart10_9.vue?vue&type=template&id=0ed37302&"
import script from "./CreatePart10_9.vue?vue&type=script&lang=js&"
export * from "./CreatePart10_9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports